import { Box, Skeleton } from '@mui/material';

import TableSkeleton from '@root/components/table/skeleton';
// import CloudProviderBarSkeleton from '@root/components/v2/content/CloudProviderBar/skeleton';
import PageContent from '@root/components/v2/layout/PageContent';
import PageHeaderSkeleton from '@root/components/v2/layout/PageHeader/Skeleton';

/**
 * @param contentOnly render just the body, without the PageContent wrapper and header skeleton —
 * used as the Suspense fallback for a tab switch inside the Inventory shell, which owns the page
 * chrome. The full-chrome version stays the default for standalone route-level use.
 */
function ResourceTableSkleton({ contentOnly = false }: { contentOnly?: boolean }) {
  const body = (
    <>
      {/* filter card: Category, Asset type and Risk Overview chip rows */}
      <Box className="Borders RoundedCorners" marginBottom="15px" padding="15px">
        {Array.from(new Array(3)).map((_, rowIndex) => (
          <Box key={rowIndex} display="flex" alignItems="center" gap="16px" marginBottom={rowIndex === 2 ? 0 : '15px'}>
            <Skeleton variant="rectangular" width="90px" height="20px" sx={{ borderRadius: '4px' }} />
            <Box display="flex" flexWrap="wrap" gap="8px">
              {Array.from(new Array(6)).map((_, chipIndex) => (
                <Skeleton
                  key={chipIndex}
                  variant="rectangular"
                  width={chipIndex % 2 === 0 ? '130px' : '160px'}
                  height="30px"
                  sx={{ borderRadius: '15px' }}
                />
              ))}
            </Box>
          </Box>
        ))}
      </Box>

      {/* the table's own search + filter bar */}
      <Box marginBottom="15px">
        <Skeleton height="30px" style={{ transform: 'none' }} />
      </Box>

      <Box height={'63.7vh'}>
        <TableSkeleton />
      </Box>
    </>
  );

  if (contentOnly) return body;

  return (
    <PageContent>
      <PageHeaderSkeleton isRegionFilter={false} />
      {/* <CloudProviderBarSkeleton /> */}
      {body}
    </PageContent>
  );
}

export default ResourceTableSkleton;
